(function(angular){
    'use strict';

    angular.module('onvio.setup').controller('LoginHistoryCtrl', loginHistoryModal);
    loginHistoryModal.$inject = ['$sce', '$uibModalInstance', 'onvio.reports.onvioUsageService', 'userId', 'email', 'name', '$scope', '$translate', '$q', '$window'];

    function loginHistoryModal($sce, $uibModalInstance, onvioUsageService, userId, email, name, $scope, $translate, $q, $window){
        /*jshint validthis:true */
        var vm = this;
        vm.openStartDatePicker = openStartDatePicker;
        vm.openEndDatePicker = openEndDatePicker;
        vm.dateRangeChanged = dateRangeChanged;
        vm.closeSampleModal = closeSampleModal;
        vm.customCollectionViewFilter = customCollectionViewFilter;
        vm.dateToday = new Date();
        vm.endDate = vm.dateToday;
        vm.startDate = moment(vm.dateToday).subtract(30, 'days').toDate(); // jshint ignore:line
        vm.minStartDate = moment(vm.dateToday).subtract(12, 'months').toDate(); // jshint ignore:line
        vm.startDatePickerOptions = {
            maxDate: vm.dateToday,
            minDate: vm.minStartDate
        };

        vm.endDatePickerOptions = {
            minDate: vm.startDate,
            maxDate: vm.dateToday
        };
        vm.name = name;
        vm.email = email;

        getTranslations();
        function getTranslations() {
            var promises = [
                $translate('Bluemoon.Practice.Common.Actions.Export'),
                $translate('Reports.OnvioUsage.Email'),
                $translate('Reports.OnvioUsage.ColumnHeader.FullName'),
                $translate('Reports.OnvioUsage.ColumnHeader.LoginTime'),
                $translate('Reports.OnvioUsage.ColumnHeader.IpAddress'),
                $translate('Reports.OnvioUsage.ShowHideColumns'),
                $translate('Reports.OnvioUsage.LoginHistory')
            ];

            $q.all(promises).then(function(translations){
                /*Bento Toolbar*/
                vm.exportLabel = translations[0];
                vm.toolbarButtons = [{
                    label: vm.exportLabel,
                    icon: 'bento-icon-exit',
                    action: function() {
                        vm.exportExcel();
                    }
                }];
                /*Column Headers*/
                vm.loginHeader = translations[1];
                vm.fullNameHeader = translations[2];
                vm.loginTimeHeader = translations[3];
                vm.ipAddressHeader = translations[4];
                /*Tooltip*/
                vm.showHideColumns = translations[5];

                vm.loginHistory = translations[6];
                loadDetails();
            });

        }

        function loadDetails(){
            onvioUsageService.loadLoginHistoryDetail(userId, moment(vm.startDate).format('YYYY-MM-DD'), moment(vm.endDate).format('YYYY-MM-DD')).then(function(result){ // jshint ignore:line
                var data = result.data.items;
                data.forEach(formatColumns);
                vm.gridData = new wijmo.collections.CollectionView(result.data.items); // jshint ignore:line
                vm.gridData.sortDescriptions.push(new wijmo.collections.SortDescription('loginTime', false)); //jshint ignore:line
                vm.gridData.filter = vm.customCollectionViewFilter;
            });
        }
        function dateRangeChanged(){
            vm.startDatePickerOptions.maxDate = vm.endDate;
            vm.endDatePickerOptions.minDate = vm.startDate;
            if( !dateRangeExceeded() ) {
                vm.dateRangeExceeded = false;
                loadDetails();
            } else {
                vm.dateRangeExceeded = true;
            }
        }
        function customCollectionViewFilter(item) {
            if (!vm.filter) { return true; }
            var filter = vm.filter.toLowerCase();
            for (var k in item) {
                if(vm.flex.columns.getColumn(k) !== null && vm.flex.columns.getColumn(k).isVisible) {
                    var val = item[k];
                    if (wijmo.isString(val)) { // jshint ignore:line
                        if (val.toLowerCase().indexOf(filter) >= 0) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }
        function formatColumns(item) {
            item.name = vm.name;
            item.login = vm.email;
            item.formattedLoginTime = $window.moment(item.loginTime) // jshint ignore:line
            item.formattedLoginTime = item.formattedLoginTime.format('L LT');
        }
        $scope.$watch('vm.filter', function() {
            vm.gridData.refresh();
        });
        function dateRangeExceeded() {
            return moment(vm.startDate).isBefore(moment(vm.endDate).subtract(30, 'days')); // jshint ignore:line
        }
        function closeSampleModal(){
            $uibModalInstance.dismiss('close');
        }
        function openStartDatePicker() {
            vm.startDatePickerOpened = !vm.startDatePickerOpened;
        }
        function openEndDatePicker() {
            vm.endDatePickerOpened = !vm.endDatePickerOpened;
        }
        vm.toggleVisibility = function(column) {
            column.visible = !column.visible;
        };
        vm.exportExcel = function() {
            wijmo.grid.xlsx.FlexGridXlsxConverter.saveAsync(vm.flex, { includeCellStyles: false }, vm.name.replace(/[\s]/g, '') + vm.loginHistory + '.xlsx'); // jshint ignore:line
        };
    }
})(window.angular);
